export default class BriefingEvent {
    constructor(type) {
        this.type = type;
    }
}

BriefingEvent.CLOSE_REQUEST = "BriefingEvent.CLOSE_REQUEST";